module.exports = __webpack_public_path__ + "static/media/37-3.a610e6ec.mp3";